import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { Button } from "../components/Ui";
import { LandingPage } from "../features/landing/LandingPage";
import { ProductDetailPage } from "../features/products/ProductDetailPage";
import { LoginPage } from "../features/admin/LoginPage";
import { AdminApp } from "../features/admin/AdminApp";
import { applyPageMetadata } from "../lib/seo";
import { WeddingInvitationPage, WeddingStudioPage } from "../features/wedding/WeddingPages";
import { SteriaCashAnalyticsPage } from "../features/analytics/SteriaCashAnalyticsPage";
import { TembakMonyetnyaPage } from "../features/games/TembakMonyetnyaPage";
import { TantangBatasanmuPage } from "../features/games/TantangBatasanmuPage";
import { TantanganTerbukaPage } from "../features/games/TantanganTerbukaPage";
import { BertahanDariAnomaliPage } from "../features/games/bertahan-dari-anomali/BertahanDariAnomaliPage";
import { HappyTomatoPage } from "../features/games/HappyTomatoPage";
import { GamesHubPage } from "../features/games/GamesHubPage";
import { N1MasterAdminLoginPage, N1MasterAdminPage } from "../features/n1master/N1MasterAdmin";
import { N1MasterLegalPage, N1MasterSupportPage } from "../features/n1master/N1MasterSupport";
import { SteriaboothLegalPage, SteriaboothSupportPage } from "../features/steriabooth/SteriaboothSupport";

function AdminNoIndex() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!pathname.startsWith("/admin") && !pathname.startsWith("/apps/n1master/admin") && !pathname.startsWith("/steriacash")) return;
    const isN1MasterAdmin = pathname.startsWith("/apps/n1master/admin");
    applyPageMetadata({
      title: isN1MasterAdmin ? "N1 Master Support Admin" : "Steria House Admin",
      description: isN1MasterAdmin
        ? "Private N1 Master support administration."
        : "Private content management area for Steria House.",
      canonicalPath: pathname,
      noindex: true,
    });
  }, [pathname]);

  return null;
}

function NotFoundPage() {
  const { pathname } = useLocation();

  useEffect(() => {
    applyPageMetadata({
      title: "Page Not Found | Steria House",
      description: "The requested Steria House page could not be found.",
      canonicalPath: pathname,
      noindex: true,
    });
  }, [pathname]);

  return (
    <main className="state-page">
      <h1>Page not found</h1>
      <p>The page you are looking for may have moved or is no longer available.</p>
      <Button href="/">Back to Steria House</Button>
    </main>
  );
}

export function App() {
  return (
    <>
      <AdminNoIndex />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/projects/:slug" element={<ProductDetailPage />} />
        <Route path="/steriacash" element={<SteriaCashAnalyticsPage />} />
        <Route path="/games" element={<GamesHubPage />} />
        <Route path="/games/tembak-monyetnya" element={<TembakMonyetnyaPage />} />
        <Route path="/games/tantang-batasanmu" element={<TantangBatasanmuPage />} />
        <Route path="/games/tantangan-terbuka" element={<TantanganTerbukaPage />} />
        <Route path="/games/bertahan-dari-anomali" element={<BertahanDariAnomaliPage />} />
        <Route path="/games/happy-tomato" element={<HappyTomatoPage />} />
        <Route path="/games/alirkan-air" element={<HappyTomatoPage />} />
        <Route path="/wedding" element={<WeddingStudioPage />} />
        <Route path="/wedding/v1" element={<WeddingInvitationPage />} />
        <Route path="/wedding/v2" element={<WeddingInvitationPage version="v2" />} />
        <Route path="/apps/n1master/support" element={<N1MasterSupportPage />} />
        <Route path="/apps/n1master/privacy" element={<N1MasterLegalPage document="privacy" />} />
        <Route path="/apps/n1master/terms" element={<N1MasterLegalPage document="terms" />} />
        <Route path="/apps/n1master/admin/login" element={<N1MasterAdminLoginPage />} />
        <Route path="/apps/n1master/admin" element={<N1MasterAdminPage />} />
        <Route path="/apps/steriabooth/support" element={<SteriaboothSupportPage />} />
        <Route path="/apps/steriabooth/privacy" element={<SteriaboothLegalPage document="privacy" />} />
        <Route path="/apps/steriabooth/terms" element={<SteriaboothLegalPage document="terms" />} />
        <Route path="/admin/login" element={<LoginPage />} />
        <Route path="/admin/*" element={<AdminApp />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}
